<template>
  <pt-promotion-form class="pt-promotion-form__page" :id="id" :is-edit="is_edit" :isActive="is_active"></pt-promotion-form>
</template>

<script>
import PtPromotionForm from 'cps/mall-manage/pt-promotion-coupon/pt-promotion-form'
export default {
  name: 'pt-promotion-form__view',
  components: {
    'pt-promotion-form': PtPromotionForm
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: String,
      default: ''
    },
    isActive: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true',
      is_active: this.isActive === 'true'
    }
  }
}
</script>
